<template>
  <notifications style="z-index: 100000;" />

  <div id="app" :class="vueAppClasses">
      <router-view @setAppClasses="setAppClasses"/>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import themeConfig from '@/utils/themeConfig';
import {APIStore} from "@/utils/APIStore";
import { UserStore } from '@/utils/UserStore';
import { useI18n } from 'vue-i18n';
import { notify } from "@kyvg/vue3-notification";

//Connection
const router = useRouter();
const { locale } = useI18n();
const user = UserStore();
const loaded = ref(false);
loaded.value = true;
APIStore.refresh()
  .then(result => {
    const currentRoute = router.currentRoute.value;
    locale.value = user.getLanguage;

    const requiresAuth = currentRoute.meta?.requiresAuth === true;
    if (!result.success && requiresAuth) {
      user.disconnect();
      router.push({ name: 'login' });
    }

    loaded.value = false;

    /* user.getSettings["messagesFlash"].forEach(message => {
      notify({
        title: "Application Message",
        text: message,
        type: "info",
        duration: -1
      });

    }); */
  }).catch(e=>{
    APIStore.logout();
  });




// Références
const vueAppClasses = ref<string[]>([]);
const store = useStore();

// Méthodes
const toggleClassInBody = (className: string) => {
  if (className === 'dark') {
    document.body.classList.remove('theme-semi-dark');
    document.body.classList.add('theme-dark');
  } else if (className === 'semi-dark') {
    document.body.classList.remove('theme-dark');
    document.body.classList.add('theme-semi-dark');
  } else {
    document.body.classList.remove('theme-dark', 'theme-semi-dark');
  }
};

const setAppClasses = (classesStr: string) => {
  vueAppClasses.value.push(classesStr);
};

const handleWindowResize = () => {
  store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

const handleScroll = () => {
  store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY);
};

// Effet de surveillance des changements de thème
watch(
  () => store.state.theme,
  (val) => toggleClassInBody(val),
);

watch(
  () => store.state.rtl,
  (val) => {
    document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr');
  },
);

// Montage et démarrage
onMounted(() => {
  toggleClassInBody(themeConfig.themeConfig.theme);
  store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', handleWindowResize);
  window.addEventListener('scroll', handleScroll);

  const user = localStorage.getItem('user');

});

// Nettoyage
onUnmounted(() => {
  window.removeEventListener('resize', handleWindowResize);
  window.removeEventListener('scroll', handleScroll);
});
</script>

